import { render, staticRenderFns } from "./CatalogMessage.vue?vue&type=template&id=7a76c518"
import script from "./CatalogMessage.vue?vue&type=script&lang=ts"
export * from "./CatalogMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports